import * as React from "react";
import { getPcsPerUnitForSize } from "../pcsPerUnit";
import type { SizeDetailState } from "../useSizeDetail";

export function useItemDetailPcs(infoDetail: SizeDetailState) {
  const isPlants = infoDetail?.category_id === 1;

  const sizeNameForPcs = React.useMemo(
    () => `${infoDetail?.name || ""} ${infoDetail?.product_name || ""}`.trim(),
    [infoDetail?.name, infoDetail?.product_name],
  );

  const pcsPerUnit = React.useMemo(
    () => getPcsPerUnitForSize(sizeNameForPcs),
    [sizeNameForPcs],
  );

  const pcsPerUnitResolved = !isPlants ? pcsPerUnit : null;

  return { isPlants, pcsPerUnitResolved };
}
